import { axiosSuperAdmin, axiosUser } from '@axios/axiosInstances';
import { BACKEND_URL } from '@/config';
import { getSuperAdminToken } from '@/app/utils/localstorage';

export const LOGIN_URL = `/auth/login`;
export const LOGOUT = `/auth/logout`;
export const LINE_LOGIN_URL = `/auth/login-line`;
export const FACEBOOK_LOGIN_URL = `/auth/login-facebook`;
export const REGISTER_URL = `/auth/register`;
export const REQUEST_PASSWORD_URL = 'api/auth/forgot-password';
export const ME_URL = `/auth/me`;
export const SHOP_URL = `/shop`;
export const SHOP_INVITE = `/shop/invite`;
export const SHOP_ADMIN_URL = `/shop/admin`;
const BRANCH_LOGIN_URL = `/auth/login-branch`;
const CHECK_POINT_PASSWORD_URL = `/auth/check-point-password`;
const USER_URL = '/user';

export function login(email, password) {
  return axiosUser.post(LOGIN_URL, { email, password });
}

export function logout() {
  return axiosUser.post(LOGOUT);
}

export function lineLogin(
  lineId,
  shopId,
  lineProfile,
  email,
  alternativeLineId,
  branchFriendlyId,
  inviteCode,
  joinGroupId
) {
  return axiosUser.post(LINE_LOGIN_URL, {
    lineId,
    shopId,
    lineProfile,
    email,
    alternativeLineId,
    branchFriendlyId,
    inviteCode,
    joinGroupId
  });
}

export function facebookLogin(facebookId, accessToken, shopId, inviteCode) {
  return axiosUser.post(FACEBOOK_LOGIN_URL, { facebookId, accessToken, shopId, inviteCode });
}

export function loginToBranch(token, branchId) {
  return axiosUser.post(BRANCH_LOGIN_URL, { branchId }, { headers: { Authorization: `Bearer ${token}` } });
}

export function getTransferUserByPhone(phone, shopId) {
  return axiosUser.get(`${USER_URL}/transfer`, { params: { phone, shop: shopId } });
}

export function register({
  firstName,
  lastName,
  phone,
  gender,
  email,
  birthdate,
  lineId,
  alternativeLineId,
  linePictureUrl,
  seqId,
  lineDisplayName,
  lineEmail,
  inviteCode,
  facebookId,
  facebookProfile,
  shippingAddress,
  remark,
  password,
  re_password,
  salesName,
  countryDialCode,
  mgm,
  referral,
  hasConfirmedWhatsapp,
  userReferral,
  refId,
  branchFriendlyId,
  custom1,
  custom2,
  custom3,
  custom4,
  custom5,
  custom6,
  custom7,
  customFields = [],
  joinGroupId,
  isUnsubscribed,
  lang,
  pin,
  registrationCode
}) {
  return axiosUser.post(REGISTER_URL, {
    firstName,
    lastName,
    gender,
    phone,
    email,
    birthdate,
    lineId,
    alternativeLineId,
    linePictureUrl,
    seqId,
    lineDisplayName,
    lineEmail,
    inviteCode,
    facebookId,
    facebookProfile,
    shippingAddress,
    remark,
    password,
    re_password,
    salesName,
    mgm,
    referral,
    countryDialCode,
    hasConfirmedWhatsapp,
    userReferral,
    refId,
    registeredBranchFriendlyId: branchFriendlyId,
    custom1,
    custom2,
    custom3,
    custom4,
    custom5,
    custom6,
    custom7,
    customFields,
    joinGroupId,
    isUnsubscribed,
    lang,
    pin,
    registrationCode
  });
}

export function requestPassword(email) {
  return axiosUser.post(REQUEST_PASSWORD_URL, { email });
}

export function getUserByToken(token) {
  // Authorization head should be fulfilled in interceptor.
  return axiosUser.get(ME_URL, { headers: { Authorization: `Bearer ${token}` } });
}

export function createShop(formdata) {
  return axiosSuperAdmin.post(SHOP_URL, formdata);
}

export function editShop(id, formdata) {
  return axiosSuperAdmin.patch(`${SHOP_URL}/${id}`, formdata);
}

export function getShop() {
  return axiosSuperAdmin.get(SHOP_URL);
}

export function getShopBySeqId(id) {
  return axiosSuperAdmin.get(`${SHOP_URL}/${id}`);
}

export function shopinvite(id) {
  return axiosSuperAdmin.get(`${SHOP_INVITE}/${id}`);
}

export function searchShops(opts) {
  const { name, pageIndex, pageSize } = opts;
  return axiosSuperAdmin.get(`${SHOP_URL}`, {
    params: {
      name,
      pageNumber: pageIndex != null ? pageIndex + 1 : undefined,
      pageSize: pageSize != null ? pageSize : undefined
    }
  });
}

export function editShopByAdmin(id, formdata) {
  return axiosUser.patch(`${SHOP_ADMIN_URL}/${id}`, formdata);
}

export function getShopInfo(seqId) {
  return axiosUser.get(`${SHOP_URL}/${seqId}`);
}

export function checkPasswordForResetPoint(password) {
  return axiosUser.post(`${CHECK_POINT_PASSWORD_URL}`, { password });
}

export const clearAllPoints = shopId => {
  return axiosUser.post(`/customer/clear-all-point`, shopId);
};

export const clearShopPoints = () => {
  return axiosUser.post(`/customer/clear-points`);
};

export const clearShopSales = () => {
  return axiosUser.post(`/customer/clear-sales`);
};
export function changeTierDisplay(isShowTierCard) {
  return axiosUser.patch(`${SHOP_URL}/edit-setting/tier-display`, { isShowTierCard });
}

export function changeTierCardDisplay(tierCardDisplay) {
  return axiosUser.patch(`${SHOP_URL}/edit-setting/tier-card-fields`, { tierCardDisplay });
}

export function getShopFeatureMiniPOS(shopId) {
  return axiosSuperAdmin.get(`${SHOP_URL}/mini-pos/${shopId}`)
}

export function upsertShopFeatureMiniPOS(shopId, data) {
  return axiosSuperAdmin.put(`${SHOP_URL}/mini-pos/${shopId}`, data)
}

export function requestDeleteShopImagesOtp(shopId) {
  return axiosSuperAdmin.post(`${SHOP_URL}/${shopId}/images/otp`);
}

// Streams NDJSON progress events from the delete-images endpoint. `onEvent`
// is called with each parsed JSON line as it arrives, e.g.
// { type: "section-start" | "progress" | "section-done" | "complete" | "error", ... }
export async function deleteShopImagesStream(shopId, otpId, code, onEvent) {
  const response = await fetch(`${BACKEND_URL}${SHOP_URL}/${shopId}/images`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getSuperAdminToken()}`
    },
    body: JSON.stringify({ otpId, code })
  });

  if (!response.ok || !response.body) {
    const data = await response.json().catch(() => ({}));
    throw new Error(data.message || 'Failed to delete images');
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';

  for (;;) {
    const { done, value } = await reader.read();
    if (done) break;

    buffer += decoder.decode(value, { stream: true });
    const lines = buffer.split('\n');
    buffer = lines.pop();

    lines.filter(Boolean).forEach(line => {
      try {
        onEvent(JSON.parse(line));
      } catch (e) {
        console.error('Failed to parse progress event', line, e);
      }
    });
  }

  if (buffer.trim()) {
    try {
      onEvent(JSON.parse(buffer));
    } catch (e) {
      console.error('Failed to parse progress event', buffer, e);
    }
  }
}

